export default __webpack_public_path__ + "static/media/stefan.fad1823c.webp";